import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { v2Href } from "../publicRoutes";
import "./navbarV2.css";

const logo = require("../../assets/images/BDR-logo.png");

const NavbarV2 = ({ preview = false }) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  const LINKS = [
    { label: "Home", to: v2Href(preview, "home"), end: true },
    { label: "Our Doors", to: v2Href(preview, "ourDoors") },
    { label: "Contact", to: v2Href(preview, "contact") },
  ];

  return (
    <header className="bdrv2-nav">
      <div className="bdrv2-nav-inner bdrv2-container">
        <Link to={v2Href(preview, "home")} className="bdrv2-nav-brand" onClick={close}>
          <img src={logo} alt="Biggin's Door Refinishing" />
          <span className="bdrv2-nav-brand-name">
            <span className="bdrv2-nav-brand-big">Biggin&apos;s</span>
            <span className="bdrv2-nav-brand-sub">Door Refinishing</span>
          </span>
        </Link>

        <button
          type="button"
          className={`bdrv2-nav-burger${open ? " open" : ""}`}
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`bdrv2-nav-links${open ? " open" : ""}`}>
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `bdrv2-nav-link${isActive ? " active" : ""}`
              }
              onClick={close}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to={v2Href(preview, "quote")}
            className="bdrv2-btn bdrv2-btn--primary bdrv2-nav-cta"
            onClick={close}
          >
            Get a Free Quote
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default NavbarV2;
